import { ReactElement } from 'react'
import { PlanImageCardForm } from '@structuralPlanningComponents'
import { Box, Typography } from '@mui/material'
import { usePlanImageCardStore } from '@editorStores'
import { useSelectedPlanElementId } from '@editorHooks'

interface Props {
  /** Shows a close button in the form's header when given. */
  onClose?: () => void
}

const PlanImageCardDrawer = ({ onClose }: Props): ReactElement => {
  const selectedId = useSelectedPlanElementId('image-card')
  const selectedCard = usePlanImageCardStore(state =>
    selectedId ? state.cards.find(card => card.id === selectedId) : undefined,
  )

  if (!selectedCard) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary" data-cy="plan-image-card-drawer-empty">
          Bitte ein Plan-Bild auswählen
        </Typography>
      </Box>
    )
  }

  return <PlanImageCardForm onClose={onClose} />
}

export default PlanImageCardDrawer
